import { routeNames } from 'src/modules/core/constants/routeNames'
import { GeneralLayout, MainLayout, SecondaryLayout } from 'src/modules/core/layout'
import type { RouteType } from 'src/modules/core/types/routes.types'
import {
  AppointmentManage,
  BetaUsersSubscription,
  Booking,
  BookingConfirmed,
  BookingDetails,
  CanceledSubscription,
  CancelPlan,
  Configuration,
  Confirmation,
  ConnectedAppAuthorize,
  ConnectedAppLogin,
  Dashboard,
  ForceLogout,
  Impersonate,
  LateCancels,
  Login,
  Meet,
  PausedSubscription,
  Privacy,
  RescheduleBooking,
  Settings,
  SubscriptionPlans,
  SyncCalendar,
  Terms,
} from 'src/pages'
import { BookingOnboarding } from 'src/pages/booking-onboarding'
import { LoginWithToken } from 'src/pages/login-with-token'
import { RedirectToReschedule } from 'src/pages/reschedule-booking/redirect-to-reschedule'
import { Support } from 'src/pages/support'

export const routes: RouteType[] = [
  {
    layout: SecondaryLayout,
    pathLayout: routeNames.onboarding.relative,
    components: [
      {
        relativePath: routeNames.configuration.relative,
        path: routeNames.configuration.path,
        component: Configuration,
        restricted: true,
      },
      {
        relativePath: routeNames.login.relative,
        path: routeNames.login.path,
        component: Login,
        restricted: false,
      },
      {
        relativePath: routeNames.connectedAppAuthorize.relative,
        path: routeNames.connectedAppAuthorize.path,
        component: ConnectedAppAuthorize,
        restricted: false,
      },
      {
        relativePath: routeNames.loginWithToken.relative,
        path: routeNames.loginWithToken.path,
        component: LoginWithToken,
        restricted: false,
      },
      {
        relativePath: routeNames.impersonate.relative,
        path: routeNames.impersonate.path,
        component: Impersonate,
        restricted: false,
      },
      {
        relativePath: routeNames.connectedAppLogin.relative,
        path: routeNames.connectedAppLogin.path,
        component: ConnectedAppLogin,
        restricted: false,
      },
      {
        relativePath: routeNames.forceLogout.relative,
        path: routeNames.forceLogout.path,
        component: ForceLogout,
        restricted: false,
      },
      {
        relativePath: routeNames.bookingOnboarding.relative,
        path: routeNames.bookingOnboarding.path,
        component: BookingOnboarding,
        restricted: true,
      },
      {
        relativePath: routeNames.syncCalendar.relative,
        path: routeNames.syncCalendar.path,
        component: SyncCalendar,
        restricted: true,
      },
    ],
  },
  {
    layout: MainLayout,
    pathLayout: routeNames.dashboardPrefix.relative,
    components: [
      {
        relativePath: routeNames.dashboard.relative,
        path: routeNames.dashboard.path,
        component: Dashboard,
        restricted: true,
      },
      {
        relativePath: routeNames.settings.relative,
        path: routeNames.settings.path,
        component: Settings,
        restricted: true,
      },
      {
        relativePath: routeNames.lateCancels.relative,
        path: routeNames.lateCancels.path,
        component: LateCancels,
        restricted: true,
      },
    ],
  },
  {
    layout: GeneralLayout,
    pathLayout: routeNames.home.relative,
    components: [
      {
        relativePath: routeNames.terms.relative,
        path: routeNames.terms.path,
        component: Terms,
        restricted: false,
      },
      {
        relativePath: routeNames.privacy.relative,
        path: routeNames.privacy.path,
        component: Privacy,
        restricted: false,
      },
      {
        relativePath: routeNames.confirmation.relative,
        path: routeNames.confirmation.path,
        component: Confirmation,
        restricted: false,
      },
      {
        relativePath: routeNames.meet.relative,
        path: routeNames.meet.path,
        component: Meet,
        restricted: false,
      },
      {
        relativePath: routeNames.booking.relative,
        path: routeNames.booking.path,
        component: Booking,
        restricted: false,
      },
      {
        relativePath: routeNames.bookingConfirmed.relative,
        path: routeNames.bookingConfirmed.path,
        component: BookingConfirmed,
        restricted: false,
      },
      {
        relativePath: routeNames.reschedule.relative,
        path: routeNames.reschedule.path,
        component: RescheduleBooking,
        restricted: false,
      },
      {
        relativePath: routeNames.bookingReschedule.relative,
        path: routeNames.bookingReschedule.path,
        component: RedirectToReschedule,
        restricted: false,
      },
      {
        relativePath: routeNames.bookingDetails.relative,
        path: routeNames.bookingDetails.path,
        component: BookingDetails,
        restricted: false,
      },
      {
        relativePath: routeNames.appointmentManage.relative,
        path: routeNames.appointmentManage.path,
        component: AppointmentManage,
        restricted: false,
      },
      {
        relativePath: routeNames.cancelPlan.relative,
        path: routeNames.cancelPlan.path,
        component: CancelPlan,
        restricted: true,
      },
      {
        relativePath: routeNames.canceledSubscription.relative,
        path: routeNames.canceledSubscription.path,
        component: CanceledSubscription,
        restricted: true,
      },
      {
        relativePath: routeNames.pausedSubscription.relative,
        path: routeNames.pausedSubscription.path,
        component: PausedSubscription,
        restricted: true,
      },
      {
        relativePath: routeNames.betaUsersSubscription.relative,
        path: routeNames.betaUsersSubscription.path,
        component: BetaUsersSubscription,
        restricted: true,
      },
      {
        relativePath: routeNames.subscriptionPlans.relative,
        path: routeNames.subscriptionPlans.path,
        component: SubscriptionPlans,
        restricted: true,
      },
      {
        relativePath: routeNames.support.relative,
        path: routeNames.support.path,
        component: Support,
        restricted: false,
      },
    ],
  },
]
